import s from './AppLoadingScreen.module.css';

export default function AppLoadingScreen({ children }) {
  return (
    <div className={s.screen}>
      {/* WanderWords wordmark — large background watermark */}
      <img
        src="/assets/wanderwords-logo-wordmark.svg"
        alt=""
        className={s.wordmark}
        aria-hidden="true"
      />

      {/* Story-ship with float animation */}
      <div className={s.shipWrap} aria-hidden="true">
        <img
          src="/assets/story-ship.webp"
          alt=""
          className={s.ship}
        />
      </div>

      {/* Scrolling cloud-band at the cream/teal seam */}
      <div className={s.cloudBand} aria-hidden="true" />

      {/* Teal fill block — bottom of screen */}
      <div className={s.tealFill} />

      {/* Loading text / error content */}
      <div className={s.loadingArea}>
        {children ? children : (
          <p className={s.loadingText} aria-label="Loading">
            Loading
            <span className={s.dot} aria-hidden="true">.</span>
            <span className={s.dot} aria-hidden="true">.</span>
            <span className={s.dot} aria-hidden="true">.</span>
            <span className={s.dot} aria-hidden="true">.</span>
          </p>
        )}
      </div>
    </div>
  );
}
